import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useRef, useState } from 'react';
import { CheckIcon, LinkIcon } from '@primer/octicons-react';
import { LTTooltip } from '@lambdatestincprivate/lt-components';

/**
 * Copies the CURRENT URL — which, because the URL mirrors the whole view
 * state (?test/?step/?dock/?tab/?issue, see app/url-sync.ts), is always a
 * deep link to exactly what the user is looking at. Unstyled beyond the
 * caller's className so each surface (detail header, RCA drawer) keeps its
 * local button look. The LTTooltip names the action (QA: the bare icon
 * wasn't identifiable) and flips to confirm the copy.
 */
import { jsx as _jsx } from "react/jsx-runtime";
export function CopyLinkButton(_ref) {
  var className = _ref.className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 16 : _ref$size;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    copied = _useState2[0],
    setCopied = _useState2[1];
  var timer = useRef(null);
  useEffect(function () {
    return function () {
      if (timer.current) clearTimeout(timer.current);
    };
  }, []);
  var copy = function copy() {
    if (navigator.clipboard) {
      void navigator.clipboard.writeText(window.location.href);
    }
    setCopied(true);
    if (timer.current) clearTimeout(timer.current);
    timer.current = setTimeout(function () {
      return setCopied(false);
    }, 1500);
  };
  return /*#__PURE__*/_jsx(LTTooltip, {
    text: copied ? 'Link copied!' : 'Copy link to this view',
    direction: "bottom",
    customTriggerStyle: {
      display: 'inline-flex'
    },
    children: /*#__PURE__*/_jsx("button", {
      type: "button",
      className: className,
      "aria-label": copied ? 'Link copied' : 'Copy link to this view',
      onClick: copy,
      children: copied ? /*#__PURE__*/_jsx(CheckIcon, {
        size: size,
        "aria-hidden": "true"
      }) : /*#__PURE__*/_jsx(LinkIcon, {
        size: size,
        "aria-hidden": "true"
      })
    })
  });
}